export const environment = {
    production: true,
    company: 'smartpay' as const,
    companyName: 'SmartPay',
    logo: 'assets/images/logo/smartpay-logo.svg',
    staging: true,
    baseUrl: 'https://smartpay-central-sso-qa.pozitivehub.com/',
    apiUrl: 'https://smartpay-sso-qa.pozitivehub.com/api/',
    waterUrl:'http://157.245.44.23:9090/quotation/add',
    hubconnection: 'https://smartpay-sso-qa.pozitivehub.com/api/emailVerifaction',
    redirectUrl :'https://smartpay-sso-qa.pozitivehub.com',
    ssourl: "https://smartpay-sso-qa.pozitivehub.com",
    authConfig: {
        authority: "https://smartpay-sso-qa.pozitivehub.com/",
        redirectUrl: "https://smartpay-central-sso-qa.pozitivehub.com/",
        postLogoutRedirectUri: 'https://smartpay-central-sso-qa.pozitivehub.com/signout-callback-oidc',
        clientId: "central-spa-qa",
        scope: 'openid profile email roles offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        accounturl:"https://smartpay-account-qa.pozitivehub.com/",
    },
    20: "Water",
    10 : "Elect",
    11 : "Gas",
    30 : "Mobile",
    40 : "Issuing",
    41 : "Acquiring",
    42 : "Lending",
    50: "EVC" ,
    60 : "Partner",
    70: "Tech Tool Kit",
    71: "HR",
    72: "Accounting",
    73: "Rewards",
    74: "Analytics",
    99: "Test"
};
